/* eslint-disable import/prefer-default-export */
export const PER_PAGE = 40;



// WEBPACK FOOTER //
// ./src/constants/pagination.js